/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  container: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    left: 0,
    top: 0,
    zIndex: 9999,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.2)',
  },
  panel: {
    padding: 20,
    width: 280,
  },
  formControl: {
    width: '100%',
  },
  formControlLabel: {
    justifyContent: 'space-between',
  },
}));
